/** A single no-op function. This single instance is useful mainly for callback
 * props so that react doesn't see new functions and re-render... but there's a tiny
 * performance boost for using it in other cases too.
 */
export function noOp() {
  /* Intentionally empty */
}
